const MOTIFS_IRRECEVABILITE = [
  {
    key: 0,
    test: '',
    value: 0,
  },
  {
    key: 1,
    text: "L'un ou les deux partenaires ne sont pas majeurs(mêmes émancipés) ",
    value: 1,
  },
  {
    key: 2,
    text: 'Liens de parenté : Ascendant et descendant en ligne direct',
    value: 2,
  },
  {
    key: 3,
    text: 'Liens de parenté : Alliés en ligne direct',
    value: 3,
  },
  {
    key: 4,
    text: "Liens de parenté : Collatéraux jusqu'aux troisième degré inclus",
    value: 4,
  },
  {
    key: 5,
    text: "L'un des partenaire au moins est engagé dans les liens d'un mariage",
    value: 5,
  },
  {
    key: 6,
    text: "L'un des partenaires au moins est déjà lié par un PACS",
    value: 6,
  },
  {
    key: 7,
    text: "L'un ou les deux partenaires font l'objet d'une mesure de protection",
    value: 7,
  },
  {
    key: 8,
    text: 'Absence de production des pièces justificatives',
    value: 8,
  },
  {
    key: 9,
    text: "Incompétence territoriale de l'officier de l'état civil",
    value: 9,
  },
  {
    key: 10,
    text: "Liens de parenté : Collatéraux jusqu'aux troisième degré inclus",
    value: 10,
  },
];

export default MOTIFS_IRRECEVABILITE;
